import React, { useState, useEffect } from "react";
import { CModal, CModalBody } from "@coreui/react";
import crossButton from "../../../components/assets/image/crossButton.svg";

const AddPriorityPopup = ({ userData = {}, buttonLabel = "Select Priority", onSubmit }) => {
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [selectedPriority, setSelectedPriority] = useState("");

    const priorityOptions = [
        { value: 1, label: "Low" },
        { value: 2, label: "Medium" },
        { value: 3, label: "High" },
    ];

    useEffect(() => {
        if (userData.priority !== undefined && userData.priority !== null) {
            setSelectedPriority(userData.priority);
        }
    }, [userData]);

    const handleSubmit = () => {
        if (selectedPriority === "") {
            alert("Please select a priority");
            return;
        }

        onSubmit(selectedPriority);


        console.log("DATATTATA::::", selectedPriority);
        setIsModalVisible(false);
    };

    return (
        <div>
            <button
                onClick={() => setIsModalVisible(true)}
                style={{
                    backgroundColor: "black",
                    color: "white",
                    border: "none",
                    cursor: "pointer",
                    borderRadius: "4px",
                    fontSize: "10px",
                    minWidth: "60px",
                    height: "24px",
                    padding: "2px 5px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }}
            >
                {userData.priority ? "Update Priority" : buttonLabel}
            </button>

            <CModal alignment="center" visible={isModalVisible} onClose={() => setIsModalVisible(false)}>
                <CModalBody style={{ padding: "20px", position: "relative" }}>
                    <img
                        onClick={() => setIsModalVisible(false)}
                        src={crossButton}
                        alt="close"
                        style={{ position: "absolute", top: 10, right: 10, cursor: "pointer", width: "20px", height: "20px" }}
                    />

                    <h4 style={{ textAlign: "center", marginBottom: "20px" }}>        {userData.priority ? "Update Priority" : buttonLabel}
                    </h4>

                    <label className="form-label fw-bold">Priority</label>
                    <select
                        value={selectedPriority}
                        onChange={(e) => setSelectedPriority(Number(e.target.value))}
                        className="form-control mb-3"
                    >
                        <option value="">-- Select Priority --</option>
                        {priorityOptions.map((priority) => (
                            <option key={priority.value} value={priority.value}>
                                {priority.label}
                            </option>
                        ))}
                    </select>

                    <button onClick={handleSubmit} className="w-100 btn btn-md btn-warning fw-bold text-light button-color"
                        type="button">
                        Submit
                    </button>
                </CModalBody>
            </CModal>
        </div>
    );
};

export default AddPriorityPopup;
